import "./Contacts.scss";
import team from "../../img/contact.jpg"
import facebook from "../../img/facebook.png"
import instagram from "../../img/instagram.png"
import tiktok from "../../img/tiktok.svg"
import linkedin from "../../img/linkedin.svg"
import star from "../../img/star.png"

const Contacts = ({id}) => {
    return (
        <section className="Contacts" id={id}>
            <h2>Contact us</h2>
            <div className="Contacts-main">
                <img alt="UCU Space Robotics Team" className="Contacts-main-pic" src={team}/>
                <div className="Contacts-main-links">
                    <div className="Contacts-main-links-email">
                        <img alt="star" className="Contacts-main-links-email-star" src={star}/>
                        <div className="Contacts-main-links-email-content">
                            <p className="Contacts-main-links-email-content-p">WRITE TO US:</p>
                            <a className="Contacts-main-links-email-content-a" href="mailto:indomitus@ucu.edu.ua">
                                indomitus@ucu.edu.ua
                            </a>
                        </div>
                    </div>
                    <div className="Contacts-main-links-smaller">
                        <div className="Contacts-main-links-smaller-row">
                            <a className="Contacts-main-links-smaller-a --instagram"
                               href="https://www.instagram.com/indomitus.ucu/" target="_blank" rel="noreferrer">
                                <img alt="instagram logotype" src={instagram}/>
                            </a>
                            <a className="Contacts-main-links-smaller-a --tiktok"
                               href="https://www.tiktok.com/@ucu.space.robotics" target="_blank" rel="noreferrer">
                                <img alt="tiktok logotype" src={tiktok}/>
                            </a>
                        </div>
                        <div className="Contacts-main-links-smaller-row">
                            <a className="Contacts-main-links-smaller-a --linkedin"
                               href="https://www.linkedin.com/in/ucu-space-robotics-1664a23b7/" target="_blank" rel="noreferrer">
                                <img alt="linkedin logotype" src={linkedin}/>
                            </a>
                            <a className="Contacts-main-links-smaller-a --facebook"
                               href="https://www.facebook.com/profile.php?id=61588639040416" target="_blank" rel="noreferrer">
                                <img alt="facebook logotype" src={facebook}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default Contacts;